import React from "react"
import styled from "styled-components"
import { GatsbyImage } from "gatsby-plugin-image"
import getGatsbyImage from "utils/getGatsbyImage"
import { PlansSelector, PlansSelectorPrice } from "./PlansSelector"

type Props = {
  title?: string
  backgroundImage?: any
  stripePrices: PlansSelectorPrice[]
}

const Wrapper = styled.div`
  position: relative;
  // background-color: #32177788;

  > .background {
    position: absolute !important;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
    object-fit: cover;
    opacity: 1;
  }
`

const Content = styled.div`
  position: relative;
  padding: 20px 0;

  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  h1 {
    font-weight: normal;
    font-size: 2em;
    margin: 0;
    margin-bottom: 0.5em;
    text-align: center;
    font-family: "Rammetto One", cursive;
    color: #fff;
    text-shadow: 0 3px 0 #afafaf, 0 5px 0 rgba(0, 0, 0, 0.3);
  }
`

export const StrapiPlansSelector = (props: Props) => {
  const prices = props.stripePrices || []

  return (
    <Wrapper className="plans-selector-component">
      {props.backgroundImage && (
        <GatsbyImage
          className="background"
          image={getGatsbyImage(props.backgroundImage.localFile)}
          alt=""
        />
      )}
      <Content>
        {props.title && (
          <div className="title">
            <h1>{props.title}</h1>
          </div>
        )}
        <PlansSelector prices={prices} />
      </Content>
    </Wrapper>
  )
}
